export default __webpack_public_path__ + "static/media/notification.cdf5fc5d.svg";